import { useAuth } from "../../../context";
import { useQuery } from "react-query";
import { PhysicalRiskApi } from "../../../api";

export function usePhysicalRiskGreggsReport(params, config) {
  const { callApi } = useAuth();
  return useQuery(["physicalRiskGreggs", params.year, params.quarter],
    () => callApi(PhysicalRiskApi.getPhysicalRiskGreggsReport, params), config);
}
